<div class="modal-ai-milvus">
    <button type="button" class="ai-milvus-close" aria-label="Close" (click)="close()">
        <i class="mdi mdi-close"></i>
    </button>
    <div class="modal-header">
        <div class="modal-header-top d-flex align-items-center">
            <div class="ai-milvus-header-left d-flex align-items-center flex-grow-1">
                <div class="ai-milvus-icon-header">
                    <img [src]="imagemIconeAi" class="ai-milvus-icon-img" alt="AI Milvus" />
                </div>
                <span class="ai-milvus-title ml-2">{{ 'AI_MILVUS' | translate }}</span>
                <span class="badge-new ml-2">BETA</span>
            </div>
        </div>
        <div class="ai-milvus-header-underline"></div>
    </div>
    <div class="modal-body">
        <div class="ai-milvus-scroll" #scrollArea>
            <div class="ai-milvus-scroll-inner">
                <div *ngIf="mensagens.length === 0" class="ai-milvus-inicial">
                    <div class="ai-milvus-icon-centro">
                        <img [src]="imagemIconeAi" class="ai-milvus-icon-img centro" alt="AI Milvus" />
                    </div>
                    <h5 class="ai-milvus-nome mt-3">{{ 'AI_MILVUS' | translate }}</h5>
                    <p class="ai-milvus-descricao">{{ 'AI_MILVUS_DESCRICAO_INICIAL' | translate }}</p>
                </div>
                <div #scrollContainer class="ai-milvus-mensagens" *ngIf="mensagens.length > 0">
                    <div *ngFor="let msg of mensagens" class="ai-milvus-msg-wrapper"
                        [ngClass]="{'ai-milvus-msg-usuario': msg.tipo === 'usuario', 'ai-milvus-msg-assistente': msg.tipo === 'assistente'}">
                        <div *ngIf="msg.tipo === 'assistente'" class="ai-milvus-msg-icon">
                            <img [src]="imagemIconeAi" class="ai-milvus-icon-img sm" alt="AI Milvus" />
                        </div>
                        <div class="ai-milvus-msg-bubble">
                            <div *ngIf="msg.carregando" class="ai-milvus-loading">
                                <span class="dot"></span><span class="dot"></span><span class="dot"></span>
                            </div>
                            <div *ngIf="!msg.carregando" class="ai-milvus-msg-conteudo">{{ msg.conteudo }}</div>
                            <div *ngIf="msg.tipo === 'assistente' && !msg.carregando && msg.conteudo && !msg.cancelada"
                                class="ai-milvus-msg-acoes mt-2">
                                <button type="button" class="btn btn-sm btn-link p-0 mr-2" (click)="copiarResposta(msg)"
                                    [ngbTooltip]="'COPIAR' | translate">
                                    <i class="far fa-copy"></i>
                                </button>
                                <button type="button" class="btn btn-sm btn-link p-0 mr-2"
                                    [ngClass]="{'text-success': msg.avaliacao === 'like'}"
                                    (click)="avaliarResposta(msg, 'like')"
                                    [ngbTooltip]="'CURTIR' | translate">
                                    <i class="far fa-thumbs-up"></i>
                                </button>
                                <button type="button" class="btn btn-sm btn-link p-0"
                                    [ngClass]="{'text-danger': msg.avaliacao === 'dislike'}"
                                    (click)="avaliarResposta(msg, 'dislike')"
                                    [ngbTooltip]="'NAO_CURTIR' | translate">
                                    <i class="far fa-thumbs-down"></i>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="ai-milvus-bottom-area">
            <div class="ai-milvus-sugestoes">
                <button *ngFor="let frase of frasesSugeridas" type="button"
                    class="btn btn-sm btn-outline-ai-milvus"
                    (click)="usarFraseSugerida(frase)">
                    {{ frase | translate }}
                </button>
            </div>
            <div class="ai-milvus-input-area">
                <div class="ai-milvus-input-wrapper">
                    <input type="text" class="form-control ai-milvus-input" [placeholder]="'AI_MILVUS_PLACEHOLDER' | translate"
                        [(ngModel)]="mensagemAtual" (keydown.enter)="enviarMensagem()">
                    <div class="ai-milvus-input-actions">
                        <button *ngIf="carregando" type="button" class="btn btn-ai-milvus-action btn-ai-milvus-stop"
                            (click)="pausarConsulta()" [ngbTooltip]="'PAUSAR' | translate">
                            <i class="fas fa-stop"></i>
                        </button>
                        <ng-container *ngIf="!carregando">
                            <button *ngIf="temSpeechRecognition" type="button"
                                class="btn btn-ai-milvus-action btn-ai-milvus-mic"
                                [ngClass]="{'gravando': gravando}"
                                [ngbTooltip]="gravando ? ('PARAR_GRAVACAO' | translate) : ('SPEECH_TO_TEXT' | translate)"
                                (click)="toggleGravacao()">
                                <span class="ai-milvus-mic-icon">
                                  <i *ngIf="!gravando" class="fas fa-microphone"></i>
                                  <i *ngIf="gravando" class="fas fa-stop"></i>
                                </span>
                                <span *ngIf="gravando" class="ai-milvus-mic-pulse"></span>
                            </button>
                            <button type="button" class="btn btn-ai-milvus-action btn-ai-milvus-send" (click)="enviarMensagem()"
                                [disabled]="!mensagemAtual?.trim()">
                                <i class="fas fa-arrow-right"></i>
                            </button>
                        </ng-container>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
